/**
 * Copyright © 2025 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import { Stack, Typography, useTheme } from '@mui/material';
import { Quote, QuoteStatus } from '../../storage/types';

export interface QuoteRejectionReasonProps {
  quote: Quote;
}

export const QuoteRejectionReason = ({ quote }: QuoteRejectionReasonProps) => {
  const theme = useTheme();

  if (quote.status !== QuoteStatus.Rejected) {
    return null;
  }

  return (
    <Stack spacing={1}>
      <Typography variant='h4' fontWeight={700} color={theme.colors.primary500}>
        Reason quote was declined
      </Typography>
      <Typography variant='body2' fontWeight={700}>
        {quote.declined?.reason}
      </Typography>
      <Stack direction='row' spacing={1}>
        <Typography variant='body2' fontWeight={400} color={theme.colors.grey700}>
          {`${quote.declined?.declinedByName}: `}
        </Typography>
        <Typography variant='body2' fontWeight={400} color={theme.colors.grey900}>
          {quote.declined?.notes}
        </Typography>
      </Stack>
    </Stack>
  );
};

